var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v("Reboot Management")]),
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "warning",
                        dense: ""
                      }
                    },
                    [
                      _vm._v(
                        " Warning: a server reboot will immediately cause your server and any dependent services to become unavailable. This functionality should be used with extreme caution! "
                      )
                    ]
                  ),
                  _c("v-checkbox", {
                    attrs: {
                      label:
                        "I understand this will restart my server immediately."
                    },
                    model: {
                      value: _vm.model.checkbox,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "checkbox", $$v)
                      },
                      expression: "model.checkbox"
                    }
                  }),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "ml-0",
                      attrs: {
                        color: "primary",
                        disabled: !_vm.model.checkbox || _vm.button.loading,
                        loading: _vm.button.loading
                      },
                      on: {
                        click: _vm.reboot
                      }
                    },
                    [_vm._v(" Reboot ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }